import { useCallback, useMemo } from 'react';
import { ProductItemStateFee } from './use-product-item-data';

export interface ProductItemFeesReturn {
  updateFee: (fee: ProductItemStateFee, amount: number) => void;
  resetFee: (fee: ProductItemStateFee) => void;
}

export const useProductItemFees = ({
  onChangeFee,
  onResetFee,
}: {
  onChangeFee?: (fee: ProductItemStateFee, amount: number) => void;
  onResetFee?: (fee: ProductItemStateFee) => void;
}): ProductItemFeesReturn => {
  const updateFee = useCallback(
    (fee: ProductItemStateFee, amount: number) => {
      onChangeFee?.(fee, amount);
    },
    [onChangeFee],
  );

  const resetFee = useCallback(
    (fee: ProductItemStateFee) => {
      onResetFee?.(fee);
    },
    [onResetFee],
  );

  return useMemo(
    () => ({
      updateFee,
      resetFee,
    }),
    [updateFee, resetFee],
  );
};
